<script>
    export default {
        name: "url-linked-files-field",
        props: [
            'value',
        ],
        data: function () {
            return {
                files: this.value,
            }
        },
        computed: {
            translations() {
                return {
                    description: Lang.langGet("Drop media files here to attach them"),
                    title: Lang.langGet("Linked Files"),
                }
            },
            classes() {
                return {
                    container: 'v-input v-input--dense theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined',
                }
            },
            dropzoneStyle: function () {
                return {
                    'margin-bottom': '5px',
                    'margin-top': '10px',
                    'max-height': '100px',
                    'display': 'flex',
                    'flex-wrap': 'wrap',
                    'align-content': 'flex-start',
                    'row-gap': '2px',
                    'overflow-y': 'scroll',
                    'cursor': 'default'
                }
            }
        },
        watch: {
            value: function () {
                this.files = this.value;
            },
        },
        mounted: function () {
            this.files = this.value;

            EaseEventBus.fire('reinitializeDragula');

            EaseEventBus.listen('activeElementDataLinkedFileAdd', (element) => {
                if (!this.files?.length) {
                    this.files = [element];
                } else if (!this.files?.some((elem) => elem.id === element.id)) {
                    this.files.push(element);
                }

                EaseEventBus.fire('activeElementDataLinkedFileChanged', this.files);
            });
        }
    }
</script>

<template>
    <div :class="classes.container">
        <div class="v-input__control">
            <div class="v-input__slot">
                <fieldset aria-hidden="true">
                    <legend style="width: 0;"><span class="notranslate">​</span>
                    </legend>
                </fieldset>
                <div class="v-text-field__slot" style="max-width: 100%;">
                    <label for="input-linked-files"
                           class="v-label v-label--active theme--light"
                           style="left: 0; right: auto; position: absolute; background:white; margin-left:-5px; padding:0 5px;">
                        {{ translations.title }}
                    </label>
                    <div id="input-linked-files" data-type="picture|video|pdf|ppt|other" class="attach-dropzone"
                         :style="dropzoneStyle">
                        <v-chip v-for="(file, index) in files"
                            :key="`linked-file-${index}`"
                            class="elevation-1 mr-1 linked-file-container"
                            small label color="primary"
                            @click="$emit('click', file, index)"
                        >
                            <span class="linked-file-name">{{ file.name }}</span>
                            <i class="fa-regular fa-xmark ml-2" />
                        </v-chip>
                    </div>
                </div>
            </div>
            <div class="v-text-field__details">
                <div class="v-messages theme--light">
                    <div class="v-messages__wrapper">
                        <div class="v-messages__message"> {{ translations.description }} </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
.linked-file-container {
    max-width: 100%;
}

.linked-file-name {
    min-width: 0;
    flex-shrink: 1;
    overflow: hidden;
    overflow: clip;
    text-overflow: ellipsis;
}
</style>
